/**
 * Created by hernanherreros on 2019-05-03
 */

import * as React from 'react'
import LocaleContext, { LocaleContextInterface } from './localeContext'
import catalogEN from '../../locales/en/messages'
import catalogES from '../../locales/es/messages'
import { I18nProvider } from '@lingui/react'
import { setupI18n } from "@lingui/core"
import { Request } from 'fetchboi'

// @ts-ignore
const language = localStorage.getItem('language') || window.navigator.userLanguage || window.navigator.language
// let preferred = 'en'
// if (language.indexOf('es') > -1) {
//   preferred = 'es'
// }
let preferred = 'es'

Request.getCustomHeader = () => {
  return { 'Content-Language': preferred }
}

const i18nParams = {
  language: preferred,
  catalogs: {
    en: catalogEN,
    es: catalogES,
  },
}

export const i18n = setupI18n(i18nParams)

interface Props {
}

class LocaleProvider extends React.Component<Props, LocaleContextInterface> {
  constructor (props: Props) {
    super(props)

    this.state = {
      currentLanguage: preferred,
      setLanguage: this.setLanguage,
    }
  }

  setLanguage = (language: string) => {
    const availableLanguages = this.getAvailableLanguages()

    if (availableLanguages.indexOf(language) > -1) {
      localStorage.setItem('language', language)
      i18n.activate(language)
      this.setState({ currentLanguage: language })
      Request.getCustomHeader = () => {
        return { 'Content-Language': language }
      }
    }
  }

  getAvailableLanguages = () => {
    return Object.keys(i18nParams.catalogs)
  }

  render() {
    const { children } = this.props

    return (
      <LocaleContext.Provider value={this.state}>
        <I18nProvider language="" i18n={i18n}>
          {children}
        </I18nProvider>
      </LocaleContext.Provider>
    )
  }

}

export default LocaleProvider
